export default __webpack_public_path__ + "static/media/daily-limit.367d6b57.svg";